
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

// Function to authenticate admin users
export async function authenticateAdmin(email: string, password: string): Promise<boolean> {
  try {
    console.log("Attempting admin authentication for:", email);
    
    // Hardcoded credentials check for lou@schillaci.me (for backwards compatibility)
    if (email === "lou@schillaci.me" && password === "!Christmas25!") {
      console.log("Using hardcoded admin credentials for lou@schillaci.me");
      
      // Sign in with Supabase to get a valid session
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });
      
      if (error) {
        console.error("Admin authentication error:", error);
        toast.error("Authentication failed: " + error.message);
        return false;
      }
      
      // Store admin status in localStorage
      localStorage.setItem('isAdmin', 'true');
      localStorage.setItem('adminEmail', email);
      toast.success("Admin login successful");
      return true;
    }
    
    // If not using hardcoded credentials, proceed with Supabase auth
    console.log("Trying Supabase authentication");
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      console.error("Admin authentication error:", error);
      
      // Show specific error message based on error type
      if (error.message.includes("Invalid login credentials")) {
        toast.error("Invalid email or password. Please try again.");
      } else {
        toast.error(error.message || "Authentication failed");
      }
      
      return false;
    }

    if (!data.user) {
      toast.error("Unable to authenticate as admin");
      return false;
    }

    console.log("User authentication successful, checking admin role");

    // Check if the user has admin role
    const { data: hasAdminRole, error: roleError } = await supabase.rpc('has_role', { 
      role_param: 'admin' 
    });

    if (roleError) {
      console.error("Error checking admin role:", roleError);
      toast.error("Error verifying admin status");
      return false;
    }

    // If no admin role is found, show error and return false
    if (!hasAdminRole) {
      console.error("User does not have admin role");
      toast.error("You don't have admin privileges");
      await supabase.auth.signOut(); // Sign out the non-admin user
      return false;
    }

    console.log("Admin role verified successfully");
    // Store admin status in localStorage
    localStorage.setItem('isAdmin', 'true');
    localStorage.setItem('adminEmail', email);
    toast.success("Admin login successful");
    return true;
  } catch (error) {
    console.error("Admin authentication error:", error);
    toast.error("Admin login failed. Please try again.");
    return false;
  }
}
